/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {SwitchButtonConfiguration} from './configuration/switch-button.configuration';
import {SwitchButtonModel} from './models/switch-button.model';

@Component({
    selector: 'app-switch-button',
    templateUrl: './switch-button.component.html',
    styleUrls: ['./switch-button.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchButtonComponent {
    @Input() switchButtonConfiguration: SwitchButtonConfiguration;
    @Input() switchButtonModel: SwitchButtonModel;
    @Output() switch: EventEmitter<boolean> = new EventEmitter<boolean>();

    get hasTooltip(): boolean {
        return !!this.switchButtonConfiguration.tooltipText?.length;
    }

    get switchButtonDynamicStyles(): { [key: string]: string } {
        let style: { [key: string]: string } = {
            'column-gap': `${this.switchButtonConfiguration.spaceInBetween}px`
        };

        if (this.switchButtonConfiguration?.labelOnRight) {
            style = {
                ...style,
                'flex-direction': 'row-reverse',
                'justify-content': 'flex-end'
            };
        }
        return style;
    }

    switchTrackerDataCy(context: string): string {
        return `switch-${context}-${this.switchButtonConfiguration.label?.toLowerCase()
                .replace(/ /g, '-')}`;
    }

    toggle(event: Event): void {
        this.switchButtonModel.checked = (event.target as HTMLInputElement).checked;
        this.switch.emit((event.target as HTMLInputElement).checked);
    }
}
